import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SplashScreen from './SplashScreen';
import { JobProvider } from '../contexts/JobContext';
import { CustomerProvider } from '../contexts/CustomerContext';
import { CalendarDayNoteProvider } from '../contexts/CalendarDayNoteContext';
import { InstallerProvider } from '../contexts/InstallerContext';
import { NotificationCountsProvider } from '../contexts/NotificationCountsContext';

// All internal providers live here — they ONLY mount for authenticated users.
// Public pages (/e/:token, /estimate/:token, /contract/:token) never hit this
// component so those Firestore listeners never fire for customers.
function InternalProviders({ children }) {
  return (
    <InstallerProvider>
      <JobProvider>
        <CustomerProvider>
          <CalendarDayNoteProvider>
            <NotificationCountsProvider>
              {children}
            </NotificationCountsProvider>
          </CalendarDayNoteProvider>
        </CustomerProvider>
      </JobProvider>
    </InstallerProvider>
  );
}

export default function ProtectedRoute({ children, allowedRoles = ['manager', 'installManager', 'sales', 'officeManager'] }) {
  const { currentUser, userProfile } = useAuth();

  // Not logged in
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Wait for userProfile to load
  if (!userProfile) {
    return <SplashScreen />;
  }

  // Default to 'manager' if no role is set (for existing users without role)
  const userRole = userProfile.role || 'manager';

  // Check if user has allowed role
  if (!allowedRoles.includes(userRole)) {
    if (userRole === 'installer') {
      return <Navigate to="/installer" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return (
    <InternalProviders>
      {children}
    </InternalProviders>
  );
}